import * as React from 'react';
import Layer from '../data/Layer';
import { Overlay } from '../components/Overlay';
import { ThumbsGrid } from '../components/ThumbsGrid';
import { useState, useEffect } from 'react';
import { PatternData, getPatterns } from '../utils/FirebaseUtils';
import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import { loadFile } from '../utils';
import { trackEvent } from 'utils/Tracker';

interface Props {
  layer?: Layer;
}

export const PatternSelector: React.FunctionComponent<Props> = props => {
  const [patterns, setPatterns] = useState<PatternData[]>([]);
  const [isAdding, setIsAdding] = useState<boolean>(false);

  useEffect(() => {
    (async function asyncFunc() {
      setPatterns(await getPatterns());
    })();
  }, []);

  const didSelectPattern = async (pattern: PatternData) => {
    trackEvent('Add Pattern', { url: pattern.full });
    setIsAdding(true);
    try {
      const blob = await loadFile(pattern.full);
      const file = new File([blob], pattern.full.split('/').pop()!);
      storeDispatch(Actions.addLocalGraphics([file], props.layer));
    } catch {
      setIsAdding(false);
    }
  };

  if (isAdding) {
    return (
      <Overlay>
        <h1>Adding pattern...</h1>
      </Overlay>
    );
  }

  return (
    <Overlay>
      <ThumbsGrid title="Choose background">
        {patterns.map((g, index) => (
          <div key={index} onClick={() => didSelectPattern(g)}>
            <div className="thumbs-grid-thumb">
              <img
                src={g.small}
                // crossOrigin="anonymous"
              />
            </div>
          </div>
        ))}
      </ThumbsGrid>
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/modals/PatternSelector.tsx